(() => {
  let loading;
  const load = (src) => {
    if (window.CBREternalViewer) return Promise.resolve();
    if (!loading) loading = new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src = src;
      script.onload = resolve;
      script.onerror = () => { script.remove(); loading = null; reject(new Error('Viewer unavailable')); };
      document.head.append(script);
    });
    return loading;
  };
  function init(scope = document) {
    scope.querySelectorAll('[data-eternal-home]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog'), open = root.querySelector('[data-open-eternal]');
      const message = dialog.querySelector('[data-viewer-loading]');
      let viewer, disposed = false;
      open.addEventListener('click', async () => {
        dialog.showModal();
        if (viewer) { viewer.setVisible(true); return; }
        message.hidden = false; message.textContent = 'Loading the interactive preview…';
        try {
          await load(root.dataset.viewerSrc);
          if (disposed) return;
          if (!viewer) {
            viewer = window.CBREternalViewer.mount(dialog);
          }
          viewer.setVisible(dialog.open); message.hidden = true;
        } catch (e) { message.textContent = 'The preview could not load. Close it and try again, or watch the gameplay below.'; }
      });
      dialog.querySelector('[data-close-eternal]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { if (viewer) viewer.setVisible(false); open.focus(); });
      const unload = e => {
        if (!e.target.contains(root)) return;
        disposed = true; if (dialog.open) dialog.close(); if (viewer) viewer.destroy();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
